import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "../BillingDetailsContainer";

const localeRoot = "settings.billing.manage_billing.addons";

export const Addons = () => (
  <BillingDetailsContainer>
    <div className="flex flex-col gap-y-5">
      <div className="flex items-center justify-between">
        <Typography.LabelLg weight="semibold">
          {t(`${localeRoot}.title`)}
        </Typography.LabelLg>
        <Button variant="secondary">{t(`${localeRoot}.manage`)}</Button>
      </div>
      <div className="flex gap-x-2">
        <Icon
          type="plus-v2"
          size={16}
          useWithFillCurrentColor
          useWithStrokeCurrentColor
        />
        <Typography.BodySm color="text-default">
          {t(`${localeRoot}.no_addons`)}
        </Typography.BodySm>
      </div>
    </div>
  </BillingDetailsContainer>
);
